import React, { useRef, useEffect } from "react";
import headerLogo from "../../../assets/images/logo.png";
import { BsFillPersonFill } from "react-icons/bs";
import MyProfile from "./MyProfile/MyProfile";
import { useDetectOutsideClick } from "./useDetectOutsideClick";
import { callAPI } from "../../../axios";
import { Tooltip, IconButton } from "@mui/material";
import { Backdrop } from "@mui/material";
import SelectHotel from "./SelectHotel";
import  './TopNavigation.scss'
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuestion
} from "@fortawesome/free-solid-svg-icons";

function TopNavigation() {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const expandMyProfile = () => setIsActive(!isActive);
  let userRoleCode = JSON.parse(localStorage.getItem("userDetails"))?.roles[0]?.roleCode;
  const chainIdHotelNameMapping = JSON.parse(localStorage.getItem("userDetails"))?.chainIdHotelNameMapping?.length;

  useEffect(() => {
    let timer = null;

    const healthCheck = () => {
      callAPI("/health-check-auth", "GET")
        .then()
        .catch((error) => {
          console.warn(error);
          if (error?.response?.status === 403) {
            clearInterval(timer);
          }
        });
    };

    if (localStorage.getItem("jwt")) {
      timer = setInterval(() => {
        healthCheck();
      }, 5000);
    }
  }, []);

  const helpDocument = () =>{
    navigate("/hms/helpManual");
  }

  return (
    <div className="main-header">
      <Link to='/hms/ConfigurationNewHotel'><img src={headerLogo} alt="header logo" className="main-logo" /></Link>
      <div className="flex-items-between header-select">
        {/* {userRoleCode==="ROLE_SUPER_ADMIN"&&<SelectHotel />} */}
        <div className={`${chainIdHotelNameMapping>1 || userRoleCode==="ROLE_SUPER_ADMIN"?"":"d-none"}`}><SelectHotel userRoleCode={userRoleCode} /></div>
        <div className="help-document" onClick={helpDocument}>
        <Tooltip title="Help Documents">
          <FontAwesomeIcon icon={faQuestion} className="account-circulation"/>
          </Tooltip>
        </div>
        <div onClick={expandMyProfile}>
        <Tooltip title="My Profile">
          <IconButton className="bg-transparent">
            <BsFillPersonFill
              className="account-circulation"
            />
          </IconButton>
        </Tooltip>
        {isActive && (
          <MyProfile
            dropdownRef={dropdownRef}
            isActive={isActive}
          />
        )}
        {isActive && <Backdrop
          style={{opacity:0}}
          open={isActive}
          onClick={expandMyProfile}
        >
        </Backdrop>}
        </div>
      </div>
    </div>
  );
}

export default TopNavigation;
